import React from "react";

type Props = {
  text: string;
};

const Avatar = ({ text }: Props) => {
  return (
    <span className='avatar' title={text}>
      {text.charAt(0).toUpperCase()}
    </span>
  );
};

export default Avatar;
